<template>
    <div>
        <div ref="container" id="adyen-component"></div>
        <v-progress-circular v-if="!dropinComponent" indeterminate color="primary" size="64" width="2"/>
        <div v-else-if="method == 'adyen-card' && showInfo">
            <v-checkbox :label="$translate('Save card information for future purchases')" v-model="saveCard" />
            <v-alert type="info">
                {{$translate('SAVE_CARD_INFO')}}
            </v-alert>
        </div>
    </div>
</template>

<script>
let adyenPromise;
const loadAdyen = (live) => {
    if(!adyenPromise) {
        adyenPromise = new Promise(resolve => {
            let s = document.createElement("link");
            s.rel = 'stylesheet';
            if (live) {
                s.href = 'https://checkoutshopper-live.adyen.com/checkoutshopper/sdk/5.36.0/adyen.css';
                s.integrity = 'sha384-B+X5tfQbLgoh0kgWjroUSwJaqgQCbmEsWxP1kuyJpsWq/5j1MQzYfR2MSB8oWbib';
            } else {
                s.href = 'https://checkoutshopper-test.adyen.com/checkoutshopper/sdk/5.36.0/adyen.css';
                s.integrity = 'sha384-B+X5tfQbLgoh0kgWjroUSwJaqgQCbmEsWxP1kuyJpsWq/5j1MQzYfR2MSB8oWbib';
            }
            s.crossOrigin = 'anonymous';
            document.body.appendChild(s);

            s = document.createElement("script");
            s.id = 'adyen-integration';
            s.type = "text/javascript";
            if (live) {
                s.src = 'https://checkoutshopper-live.adyen.com/checkoutshopper/sdk/5.36.0/adyen.js';
                s.integrity = 'sha384-NqawORR6KhblmVfr8zJQU27SUUdvqomDEdWunCP8aPnCiaeqp4+moRZkCusSImyr';
            } else {
                s.src = 'https://checkoutshopper-test.adyen.com/checkoutshopper/sdk/5.36.0/adyen.js';
                s.integrity = 'sha384-NqawORR6KhblmVfr8zJQU27SUUdvqomDEdWunCP8aPnCiaeqp4+moRZkCusSImyr';
            }
            s.crossOrigin = 'anonymous';
            document.body.appendChild(s);

            const check = () => {
                if(window.AdyenCheckout) return resolve(window.AdyenCheckout);
                setTimeout(check, 100);
            }
            check();
        });
    }
    return adyenPromise;
}

export function removeCard(cardReference) {
    return new Promise((resolve, reject) => {
        window.$vue.$api.post('/api/adyen/remove_card', {ref: cardReference, legal_entity_id: window.$store.getters.selectedLegalEntityId}).then(response => {
            response.json().then(() => {
                if (response.ok) {
                    resolve();
                } else {
                    reject();
                }
            });
        });
    });
}

export default {
    name: 'zoezi-adyen-payment',

    props: {
        method: {
            title: 'Payment method',
            type: String
        },
        showInfo: {
            title: 'Display information about saving card',
            type: Boolean,
            default: true
        }
    },

    data: () => ({
        dropinComponent: null,
        saveCard: false,
        secret: null,
        data: null
    }),

    methods: {
        getData() {
            return {saveCard: this.saveCard, data: this.data};
        },
        async prepare() {
            this.$emit('change', false);
            const live = this.$store.state.settings.adyen.live;
            const AdyenCheckout = await loadAdyen(live);

            // Trustly needs to be added to paymentMethodsResponse to work unlike other methods like card or klarna
            // Trustly and all other mehtods are displayed as expected depending on if they are active/inactive in the system
            // this is a workaround for now added PROD-2164 for a proper fix
            const paymentMethodsResponse = {
                "paymentMethods": [
                    {
                        "brands": [
                            "maestro",
                            "amex",
                            "cup",
                            "diners",
                            "jcb",
                            "mc",
                            "visa"
                        ],
                        "name": "Credit Card",
                        "type": "scheme"
                    },
                    {
                        "name": "Pay later with Klarna.",
                        "type": "klarna"
                    },
                    {
                        "name": "Pay over time with Klarna.",
                        "type": "klarna_account"
                    },
                    {
                        "name": "Pay now with Klarna.",
                        "type": "klarna_paynow"
                    },
                    {
                        "name": "Trustly - Instant Bank Payment",
                        "type": "trustly"
                    }
                ]
            };

            const configuration = {
                paymentMethodsResponse: paymentMethodsResponse,
                clientKey: this.$store.state.settings.adyen.payment_key,
                environment: live ? 'live' : 'test',
                locale: 'sv-SE',
                showPayButton: false,

                paymentMethodsConfiguration: {
                    card: {
                        hasHolderName: true,
                        holderNameRequired: true,
                        disableIOSArrowKeys: false,
                    }
                },

                onChange: (state) => {
                    this.data = state.data;
                    this.$emit('change', state.isValid);
                },
                onSubmit: (state) => {
                    if(state.isValid) this.data = state.data;
                },
                onAdditionalDetails: (state) => {
                    const send = (attempt) => {
                        let details = state.data ? state.data.details : state.details;
                        this.$api.post('/api/adyen/paymentdetails', {details, secret: this.secret}).catch(() => {
                            if(attempt > 0) setTimeout(() => send(attempt - 1), 10000);
                        });
                    }
                    send(3);
                },
                onError: (error) => {
                    console.error('Error', error);
                }
            };

            const checkout = await AdyenCheckout(configuration);
            this.dropinComponent = checkout.create(this.method.substring(6)).mount(this.$refs.container);
            if (this.method != 'adyen-card') {
                this.dropinComponent.submit();
            }

            this.$emit('setup');
        },

        async handle(action, secret) {
            this.secret = secret;
            this.dropinComponent.handleAction(action);
        },

        reset() {
            this.dropinComponent.unmount();
            this.prepare();
        },

        save() {
            return new Promise((resolve, reject) => {
                let data = this.getData();
                data.legal_entity_id = this.$store.getters.selectedLegalEntityId;
                this.$api.post('/api/adyen/save_card', data).then(response => {
                    response.json().then(data => {
                        if (response.ok) {
                            let unsubscribeChannel = this.$api.subscribeChannel(data.channel2, (response) => {
                                if (response.type === 'adyen:payment') {
                                    this.handle(response.action, response.secret);
                                } else if (response.type === 'adyen:system-error') {
                                    this.loading = false;
                                    this.$store.commit('showSnackBar', {text: this.$translate('The card could not be saved')});
                                    this.reset();
                                    unsubscribeChannel();
                                    reject();
                                } else if (response.type === 'adyen:complete') {
                                    unsubscribeChannel();
                                    if (response.success) resolve();
                                    else reject(response.reason);
                                }
                            });

                        } else {
                            reject();
                        }
                    });
                });
            });
        }
    },

    mounted() {
        this.prepare();
    }
}
</script>
